import styled from "styled-components";

export const AvatarsContainer = styled.div`
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;
export const AvatarHolder = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  margin-right: -0.67rem;
`;
export const PlaceHolderCounter = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;
  color: #fff;
  background-color: #42464c;
  border-radius: 100%;
  margin-right: 1.5rem;
  margin-left: 0.8rem;
`;
